import authService from "../../../auth/AuthService";
import {
    addEditBillingOrgActionTypes,
    apiActionsBillingOrg,
    BillingOrganizationsActionTypes,
    orgTenantsCountriesActionTypes
} from "../constants/BillingOrganizationsActionConstants";

const unmountBillingOrgDetails = () => ({
    type: BillingOrganizationsActionTypes.CLEAR_BILLING_DETAILS
});

const toggleSortBillingOrg = (sortKey) => ({
    type: BillingOrganizationsActionTypes.TOGGLE_BILLING_ORG_SORT,
    payload: sortKey
})

const updatedOrg = () => ({
    type: BillingOrganizationsActionTypes.UPDATED_ORG_REFRESH,
});

const setOneOrgData = (orgDetail) => ({
    type: BillingOrganizationsActionTypes.SET_ORGANIZATION_DETAIL,
    payload: {orgDetail}
});

const setBillingOrgData = (billing_organizations) => ({
    type: BillingOrganizationsActionTypes.SET_BILLING_ORGANIZATIONS,
    payload: billing_organizations
});

const setBillingOrgForm = ({name, value, change_object}) => ({
    type: addEditBillingOrgActionTypes.SETTING_BILLING_ORG_FORM_VALUE,
    payload: {name, value, change_object},
});

const validateBillingOrgForm = (billingOrgObject) => ({
    type: addEditBillingOrgActionTypes.VALIDATE_BILLING_ORG_FORM,
    payload: {billingOrgObject}
});

const toggleAddBillingOrganizationModal = () => ({
    type: addEditBillingOrgActionTypes.TOGGLE_ADD_BILLING_ORG_MODAL
});

const toggleEditBillingOrganizationModal = () => ({
    type: addEditBillingOrgActionTypes.TOGGLE_EDIT_BILLING_ORG_MODAL
});

const openEditBillingOrganizationModal = (organizationDetail, organizationAddress, organizationBilling) => ({
    type: addEditBillingOrgActionTypes.OPEN_EDIT_BILLING_ORG_MODAL,
    payload: {organizationDetail, organizationAddress, organizationBilling}
});

// API Actions for Billing Organizations
const getOneBillingOrgDetail = (authToken, orgID) => ({
    type: apiActionsBillingOrg.GET,
    payload: {authToken, orgID}
});

const fetchTenantAssociatedServiceIds = (authToken, useCase, tenantName, type) =>({
    type: apiActionsBillingOrg.GET_SERVICE_IDS,
    payload: {authToken, useCase, tenantName, type}
})

const getBillingOrganizationsData = (authToken) => ({
    type: apiActionsBillingOrg.GET_ALL,
    payload: {authToken},
});

const addNewBillingOrg = (authToken, billingOrgObject) => ({
    type: apiActionsBillingOrg.POST,
    payload: {authToken, billingOrgObject}
});
const editCurrentBillingOrg = (authToken, billingOrgObject, orgID) => ({
    type: apiActionsBillingOrg.PUT,
    payload: {authToken, billingOrgObject, orgID}
});
const deleteCurrentBillingOrg = (authToken, orgID) => ({
    type: apiActionsBillingOrg.DELETE_CURRENT_ORG,
    payload: {authToken, orgID}
});
const deleteWarningForBillingOrg = () => ({
    type: apiActionsBillingOrg.DELETE_WARNING_FOR_BILLING,
});
const createCPUser = (authToken, portalPayload) => ({
    type: apiActionsBillingOrg.CREATE_CP_USER,
    payload: {authToken, portalPayload}
});

const getOrgTenantsAndCountries = (authToken) => ({
    type: apiActionsBillingOrg.GET_ORG_TENANTS_AND_COUNTRIES,
    payload: {authToken}
});

const setOrgTenantsCountries = (data) => ({
    type: orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES,
    payload: data
});

const setOrgTenantsCountriesLoading = () => ({
    type: orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES_LOADING,
});

const setOrgTenantsCountriesError = () => ({
    type: orgTenantsCountriesActionTypes.SET_ORG_TENANTS_COUNTRIES_ERROR,
});
const validateCreateCPUser = (portalPayload) => ({
   type: addEditBillingOrgActionTypes.VALIDATE_CP_USER,
   payload: {portalPayload}
});

const toggleEnableCPModal = () => ({
    type: addEditBillingOrgActionTypes.TOGGLE_ENABLE_CP_MODAL
});

const billingOrgGlobalSearch = (value) => ({
    type: BillingOrganizationsActionTypes.BILLING_ORG_GLOBAL_SEARCH,
    payload: value
})

export function billingOrganizationsTableSearch(value) {
    return (dispatch) => {
        dispatch(billingOrgGlobalSearch(value))
    }
}


export function setBillingOrgFormValues({name, value, change_object}) {
    return (dispatch) => {
        dispatch(setBillingOrgForm({name, value, change_object}));
    }
}

export function validateBillingOrg(billingOrgObject) {
    return (dispatch) => {
        dispatch(validateBillingOrgForm(billingOrgObject))
    }
}

export function validateCPUser(portalPayload) {
    return (dispatch) => {
        dispatch(validateCreateCPUser(portalPayload))
    }
}

// Modal Functions for Billing Org Form.
export function toggleAddBillingOrgModal() {
    return (dispatch) => {
        dispatch(toggleAddBillingOrganizationModal())
    }
}

export function openEditBillingOrgModal(organizationDetail, organizationAddress, organizationBilling) {
    return (dispatch) => {
        dispatch(openEditBillingOrganizationModal(organizationDetail, organizationAddress, organizationBilling))
    }
}

export function toggleEditBillingOrgModal() {
    return (dispatch) => {
        dispatch(toggleEditBillingOrganizationModal())
    }
}

export function toggleDeleteBillingOrgModal() {
    return (dispatch) => {
        dispatch(deleteWarningForBillingOrg())
    }
}


// API Functions for Billing Organizations
export function fetchOneOrganization(orgID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getOneBillingOrgDetail(authToken, orgID));
    }
}

export function fetchBillingOrganizationsTableData() {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(getBillingOrganizationsData(authToken));
    }
}

export function addBillingOrg(billingOrgObject) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(addNewBillingOrg(authToken, billingOrgObject))
    }
}

export function editBillingOrg(billingOrgObject, orgID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(editCurrentBillingOrg(authToken, billingOrgObject, orgID))
    }
}

export function deleteBillingOrg(orgID) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(deleteCurrentBillingOrg(authToken, orgID))
    }
}

// This function is now leveraged to take an additional parameter as
// type and dispatches correct report type action in the middleware.
export function fetchAssociatedServiceIds(useCase, tenantName, type) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(fetchTenantAssociatedServiceIds(authToken, useCase, tenantName, type))
    }
}

// API Success Actions
export function billingOrganizationsTableDataSuccess(billing_organizations) {
    return (dispatch) => {
        dispatch(setBillingOrgData(billing_organizations));
    }
}

export function getOrganizationDetailSuccess(orgDetail) {
    return (dispatch) => {
        dispatch(setOneOrgData(orgDetail));
    }
}

export function updatedOrgRefresh() {
    return (dispatch) => {
        dispatch(updatedOrg())
    }
}

export function unmountBillingOrg() {
    return (dispatch) => {
        dispatch(unmountBillingOrgDetails());
    }
}

export function createPortalUser(portalPayload) {
    return async (dispatch) => {
        const authToken = await authService.idUser();
        dispatch(createCPUser(authToken, portalPayload))
    }
}

export function toggleCPModal() {
    return (dispatch) => {
        dispatch(toggleEnableCPModal())
    }
}

export function toggleBillingOrgSort(sortKey) {
    return (dispatch) => {
        dispatch(toggleSortBillingOrg(sortKey))
    }
}

export function fetchOrgTenantsAndCountries() {
    return async (dispatch) => {
        dispatch(setOrgTenantsCountriesLoading());
        const authToken = await authService.idUser();
        dispatch(getOrgTenantsAndCountries(authToken));
    }
}

export function orgTenantsAndCountriesSuccess(data) {
    return (dispatch) => {
        dispatch(setOrgTenantsCountries(data));
    }
}

export function orgTenantsAndCountriesError() {
    return (dispatch) => {
        dispatch(setOrgTenantsCountriesError());
    }
}

const exports = {
    addEditBillingOrgActionTypes,
    BillingOrganizationsActionTypes,
    apiActionsBillingOrg,
    orgTenantsCountriesActionTypes,
}

export default exports;
